import { getSearchScope } from "@/lib/data/react-query/search/scope";
import {
  retrieveReportsOpenMattersReportV1,
  type RetrieveReportsOpenMattersReportInput,
} from "@/lib/data/requests";
import { queryKeys } from "@/lib/data/static";

export const retrieveReportsOpenMattersReportQueryOptions = (
  filters?: RetrieveReportsOpenMattersReportInput,
) => ({
  queryKey: [
    queryKeys.reports,
    "open-matters-report",
    getSearchScope(),
    filters,
  ],
  queryFn: ({ signal }: { signal: AbortSignal }) =>
    retrieveReportsOpenMattersReportV1(filters, signal),
});
